module.exports = __webpack_public_path__ + "img/introduce.6ebdb19b.png";